import styled from 'styled-components'
import { media } from 'utils/style-utils'

import { GAME_WIDTHS } from '../../styles'
import { GamesGridBox } from '../styles'

export const MobileGamesGridBox = styled(GamesGridBox)`
  grid-auto-flow: column dense;
  grid-auto-columns: ${GAME_WIDTHS.lg};
  overflow-y: scroll;

  ${media.md`
    grid-auto-columns: ${GAME_WIDTHS.md};
  `}

  ${media.sm`
    grid-auto-columns: ${GAME_WIDTHS.sm};
  `}

  ${media.xs`
    grid-auto-columns: ${GAME_WIDTHS.xs};
  `}
`
